import axios from 'axios';


export default axios.create({

    baseURL : 'https://brainbox.company/brainbox-website-email'
});